import { AnswerType } from '@app-studio-web/ui/types'
import QuizChoicePage from './QuizChoicePage'

const answers: AnswerType[] = [
  {
    emoji: '🚀',
    title: 'pages.quizOnboarding.timeCommitment.answer1',
    value: 'under_1_month',
  },
  {
    emoji: '📈',
    title: 'pages.quizOnboarding.timeCommitment.answer2',
    value: '1_to_3_months',
  },
  {
    emoji: '🎯',
    title: 'pages.quizOnboarding.timeCommitment.answer3',
    value: '4_to_6_months',
  },
  {
    emoji: '🌳',
    title: 'pages.quizOnboarding.timeCommitment.answer4',
    value: '6_plus_months',
  },
]

export default function TimeCommitmentPage() {
  return (
    <QuizChoicePage
      answers={answers}
      title="pages.quizOnboarding.timeCommitment.title"
      subtitle="pages.quizOnboarding.timeCommitment.subtitle"
    />
  )
}
